<template>
  <div v-loading="loading">
    <!-- 内容 -->
    <el-card :style="bodyStyle"
             shadow="never">
      <el-tabs v-model="activeName"
               @tab-click="handleClick">

        <!-- 调试页面 -->
        <el-tab-pane v-if="true"
                     label="调试页面"
                     name="0">
          <el-button @click="sendRequest">调试</el-button>

        </el-tab-pane>
        <!-- 服务条款 -->
        <el-tab-pane label="服务条款"
                     name="1">
          <!-- 节内容 -->
          <div style="margin-top: 20px"></div>
          <editor-content title="服务条款"
                          :attribuite="1"
                          @save="saveAgreementButton"
                          :show_content="contentAgreement"></editor-content>
        </el-tab-pane>
        <el-tab-pane label="隐私政策"
                     name="2">
          <!-- 节内容 -->
          <div style="margin-top: 20px"></div>
          <editor-content title="隐私政策"
                          :attribuite="1"
                          @save="savePrivacyButton"
                          :show_content="contentPrivacy"></editor-content>
        </el-tab-pane>
        <!-- 基本信息 -->
        <el-tab-pane label="基本信息"
                     name="3">
          <input-modify title="首页/引导页:"
                        :show_content="inputIpOrAddress"
                        @saveInputContent="saveInputContent"></input-modify>
        </el-tab-pane>
        <!-- 确认单配置 -->
        <el-tab-pane label="确认单配置"
                     name="4">确认单配置</el-tab-pane>

      </el-tabs>
    </el-card>
    <!-- dialog -->
    <el-dialog :title="'添加'+currentName"
               :visible.sync="dialogVisible"
               width="30%">

      <div>
        <el-input v-model="inputValue"
                  :placeholder="'请输入内容,当前id：'+inputId"></el-input>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="confirmSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import InputModify from '../../components/common/modify/InputModify'
import EditorModify from '../../components/common/modify/EditorV2Modify'
import { createLogger } from 'vuex'
import axios from 'axios'

import { Base64 } from 'js-base64'
let clientHeight = document.documentElement.clientHeight
let contentHeight = clientHeight - 151

export default {
  name: 'szsx-config',
  components: {
    'editor-content': EditorModify,
    'input-modify': InputModify,
  },
  data() {
    return {
      loading: true,
      bodyStyle: `min-height: ${contentHeight}px`,
      activeName: '0',
      contentAgreement: '',
      contentPrivacy: '',
      inputIpOrAddress: '',
      contentCalculateAgreement: '',
      // 配置隐私条款
      dialogVisible: false,
      currentName: '',
      inputValue: '',
      inputId: null,

      product: [],
      company: [],
      beginDate: [],
      modifyDate: [],
      email: [],
    }
  },
  mounted() {
    this.getContentAgreement(this.activeName)
  },
  methods: {
    sendRequest() {

    },


    // 添加：
    addNewItem(item) {
      this.currentName = item
      if (item == '产品名称') {
        this.inputId = this.product.length
      } else if (item == '公司名称') {
        this.inputId = this.company.length
      } else if (item == '生效日期') {
        this.inputId = this.beginDate.length
      } else if (item == '更改日期') {
        this.inputId = this.modifyDate.length
      } else if (item == '邮箱') {
        this.inputId = this.email.length
      }
      this.dialogVisible = !this.dialogVisible
    },
    confirmSubmit() {
      let item = this.currentName
      if (item == '产品名称') {
        this.product.push({
          id: this.inputId,
          name: this.inputValue,
        })
      } else if (item == '公司名称') {
        this.company.push({
          id: this.inputId,
          name: this.inputValue,
        })
      } else if (item == '生效日期') {
        this.beginDate.push({
          id: this.inputId,
          name: this.inputValue,
        })
      } else if (item == '更改日期') {
        this.modifyDate.push({
          id: this.inputId,
          name: this.inputValue,
        })
      } else if (item == '邮箱') {
        this.email.push({
          id: this.inputId,
          name: this.inputValue,
        })
      }
      // 发送请求保存
      let products = this.product
      let companys = this.company
      let beginDates = this.beginDate
      let modifyDates = this.modifyDate
      let emails = this.email
      let postItem = {
        products,
        companys,
        beginDates,
        modifyDates,
        emails,
      }
      let postItemStr = JSON.stringify(postItem)
      console.log('添加内容' + postItemStr)

      this.$http
        .post(`/post_modify_terms`, {
          content_type: this.activeName,
          content: postItemStr,
        })
        .then((res) => {
          if (res.data.errno == 0) {
            console.log('添加结果' + JSON.stringify(res.data.data))
            this.product = JSON.parse(res.data.data).products
            this.company = JSON.parse(res.data.data).companys
            this.beginDate = JSON.parse(res.data.data).beginDates
            this.modifyDate = JSON.parse(res.data.data).modifyDates
            this.email = JSON.parse(res.data.data).emails
            this.dialogVisible = false
          }
        })
    },
    getItemsList() {
      this.$http.get('get_modify_about_terms').then((res) => {
        if (res.data.errno == 0) {
          console.log('添加结果' + JSON.stringify(res.data.data))
          this.product = JSON.parse(res.data.data).products
          this.company = JSON.parse(res.data.data).companys
          this.beginDate = JSON.parse(res.data.data).beginDates
          this.modifyDate = JSON.parse(res.data.data).modifyDates
          this.email = JSON.parse(res.data.data).emails
        }
      })
    },
    getModifyAgreementButton(type) {
      this.loading = true
      this.$http
        .post('/traver_terms', {
          method: 'get',
          content_type: this.activeName,
        })
        .then((res) => {
          console.log(res)
          if (res.data.errno == '4002') {
            this.contentPrivacy = res.data.errmsg
          } else if (res.data.errno == '0') {
            this.contentCalculateAgreement = res.data.data
            this.loading = false
          }
        })
    },
    saveModifyAgreementButton(content) {
      this.$http
        .post(`/traver_terms`, {
          method: 'renew',
          content_type: this.activeName,
          content: content,
        })
        .then((res) => {
          if (res.data.errno == '4002') {
            this.contentAgreement = res.data.errmsg
          } else if (res.data.errno == '0') {
            this.contentAgreement = res.data.data
          }
        })
    },
    //------ 保持首页：
    saveInputContent(value) {
      this.$http.get(`/renew_guide_pages?address=${value}`).then((res) => {
        if (res.data.errno == '0') {
          this.inputIpOrAddress = value
          this.$notify({
            type: 'success',
            message: res.data.errmsg,
          })
        }
      })
    },
    //切换tab
    handleClick(tab) {
      // console.log(this.activeName + '|' + tab.name)
      if (tab.name == '1') {
        this.getContentAgreement(tab.name)
      } else if (tab.name == '2') {
        this.getContentPrivacy(tab.name)
      } else if (tab.name == '3') {
        this.getGuidePages()
      } else if (tab.name == '5') {
        this.getCalculateAgreementButton(tab.name)
      } else if (tab.name == '6') {
        this.getItemsList()
        this.getModifyAgreementButton(tab.name)
      }
    },
    // 获取 引导页链接
    getGuidePages() {
      this.$http.get('/get_guide_pages').then((res) => {
        if (res.data.errno == '0') {
          this.inputIpOrAddress = res.data.address
        }
      })
    },
    // 更新 协议 内容
    saveAgreementButton(content) {
      this.$http
        .post(`/traver_terms`, {
          method: 'renew',
          content_type: this.activeName,
          content: content,
        })
        .then((res) => {
          if (res.data.errno == '4002') {
            this.contentAgreement = res.data.errmsg
          } else if (res.data.errno == '0') {
            this.contentAgreement = res.data.data
          }
        })
    },
    // 更新 隐私 内容
    savePrivacyButton(content) {
      this.$http
        .post(`/traver_terms`, {
          method: 'renew',
          content_type: this.activeName,
          content: content,
        })
        .then((res) => {
          if (res.data.errno == '4002') {
            this.contentPrivacy = res.data.errmsg
          } else if (res.data.errno == '0') {
            this.contentPrivacy = res.data.data
          }
        })
    },
    // 获取 协议 内容
    getContentAgreement(type) {
      if (this.activeName == '1') {
        this.loading = true
      } else if (this.activeName == '0') {
        this.loading = false
        return
      }

      this.$http
        .post(`/traver_terms`, {
          method: 'get',
          content_type: this.activeName,
        })
        .then((res) => {
          // console.log(res);
          if (res.data.errno == '4002') {
            this.contentAgreement = res.data.errmsg
          } else if (res.data.errno == '0') {
            this.contentAgreement = res.data.data
            this.loading = false
          }
        })
    },

    // 获取 隐私 内容
    getContentPrivacy(type) {
      this.loading = true
      this.$http
        .post(`/traver_terms`, {
          method: 'get',
          content_type: this.activeName,
        })
        .then((res) => {
          console.log(res)
          if (res.data.errno == '4002') {
            this.contentPrivacy = res.data.errmsg
          } else if (res.data.errno == '0') {
            this.contentPrivacy = res.data.data
            this.loading = false
          }
        })
    },
    // 计算器的用户协议 和隐私政策
    getCalculateAgreementButton(type) {
      this.loading = true
      this.$http
        .post('/traver_terms', {
          method: 'get',
          content_type: this.activeName,
        })
        .then((res) => {
          console.log(res)
          if (res.data.errno == '4002') {
            this.contentPrivacy = res.data.errmsg
          } else if (res.data.errno == '0') {
            this.contentCalculateAgreement = res.data.data
            this.loading = false
          }
        })
    },
    saveCalculateAgreementButton(content) {
      this.$http
        .post(`/traver_terms`, {
          method: 'renew',
          content_type: this.activeName,
          content: content,
        })
        .then((res) => {
          if (res.data.errno == '4002') {
            this.contentAgreement = res.data.errmsg
          } else if (res.data.errno == '0') {
            this.contentAgreement = res.data.data
          }
        })
    },
  },
}
</script>

<style>
.configParams {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin: 10px;
}
.paramsItem {
  width: 19%;
  min-height: 100px;
  border-radius: 10px;
  border: 1px solid #ff5421;
}
.titleAndAdd {
  width: 95%;
  margin: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.itemsInfo {
  margin: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>